/* STANLEE RECOMMENDATION REDESIGN
   Minimal vanilla JS: arrow-driven smooth scroll for the recommendation
   carousel. Mobile relies entirely on native touch scrolling + CSS scroll-
   snap, no JS required there. Does not touch product-recommendations.js or
   any existing recommendations/AJAX logic. */
(function () {
  'use strict';

  function initCarousel(viewport) {
    var section = viewport.closest('product-recommendations');
    if (!section) return;

    var prevBtn = section.querySelector('[data-stanlee-rp-prev]');
    var nextBtn = section.querySelector('[data-stanlee-rp-next]');
    if (!prevBtn && !nextBtn) return;

    function slideWidth() {
      var firstSlide = viewport.querySelector('.stanlee-rp__slide');
      if (!firstSlide) return viewport.clientWidth;
      var style = window.getComputedStyle(firstSlide.parentElement);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return firstSlide.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth - 1;
      prevBtn.disabled = viewport.scrollLeft <= 0;
      nextBtn.disabled = viewport.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        viewport.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' });
      });
    }

    viewport.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-stanlee-rp-viewport]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // STANLEE RECOMMENDATION REDESIGN: re-init after Dawn's AJAX recommendation
  // fetch swaps in new markup, and when the theme editor reloads the section.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });

  // Dawn's product-recommendations custom element replaces its own innerHTML
  // once the fetch resolves; observe for that swap and (re)bind arrows.
  document.querySelectorAll('product-recommendations').forEach(function (el) {
    var observer = new MutationObserver(function () {
      boot(el);
    });
    observer.observe(el, { childList: true });
  });
})();
